export default [
  {alpha: 'IS', name: 'アイスランド'},
  {alpha: 'IE', name: 'アイルランド'},
  {alpha: 'AZ', name: 'アゼルバイジャン'},
  {alpha: 'AF', name: 'アフガニスタン'},
  {alpha: 'VI', name: 'アメリカ領ヴァージン諸島'},
  {alpha: 'AE', name: 'アラブ首長国連邦'},
  {alpha: 'DZ', name: 'アルジェリア'},
  {alpha: 'AR', name: 'アルゼンチン'},
  {alpha: 'AW', name: 'アルバ'},
  {alpha: 'AL', name: 'アルバニア'},
  {alpha: 'AM', name: 'アルメニア'},
  {alpha: 'AI', name: 'アンギラ'},
  {alpha: 'AO', name: 'アンゴラ'},
  {alpha: 'AG', name: 'アンティグア・バーブーダ'},
  {alpha: 'AD', name: 'アンドラ'},
  {alpha: 'YE', name: 'イエメン'},
  {alpha: 'IO', name: 'イギリス領インド洋地域'},
  {alpha: 'VG', name: 'イギリス領ヴァージン諸島'},
  {alpha: 'IL', name: 'イスラエル'},
  {alpha: 'IT', name: 'イタリア'},
  {alpha: 'IQ', name: 'イラク'},
  {alpha: 'IR', name: 'イラン'},
  {alpha: 'IN', name: 'インド'},
  {alpha: 'ID', name: 'インドネシア'},
  {alpha: 'UG', name: 'ウガンダ'},
  {alpha: 'UA', name: 'ウクライナ'},
  {alpha: 'UZ', name: 'ウズベキスタン'},
  {alpha: 'UY', name: 'ウルグアイ'},
  {alpha: 'EC', name: 'エクアドル'},
  {alpha: 'EG', name: 'エジプト'},
  {alpha: 'EE', name: 'エストニア'},
  {alpha: 'ET', name: 'エチオピア'},
  {alpha: 'ER', name: 'エリトリア'},
  {alpha: 'SV', name: 'エルサルバドル'},
  {alpha: 'AU', name: 'オーストラリア'},
  {alpha: 'AT', name: 'オーストリア'},
  {alpha: 'AX', name: 'オーランド諸島'},
  {alpha: 'OM', name: 'オマーン'},
  {alpha: 'NL', name: 'オランダ'},
  {alpha: 'GH', name: 'ガーナ'},
  {alpha: 'CV', name: 'カーボベルデ'},
  {alpha: 'GG', name: 'ガーンジー島'},
  {alpha: 'GY', name: 'ガイアナ'},
  {alpha: 'KZ', name: 'カザフスタン'},
  {alpha: 'QA', name: 'カタール'},
  {alpha: 'CA', name: 'カナダ'},
  {alpha: 'GA', name: 'ガボン'},
  {alpha: 'CM', name: 'カメルーン'},
  {alpha: 'GM', name: 'ガンビア'},
  {alpha: 'KH', name: 'カンボジア'},
  {alpha: 'GN', name: 'ギニア'},
  {alpha: 'GW', name: 'ギニアビサウ'},
  {alpha: 'CY', name: 'キプロス'},
  {alpha: 'CW', name: 'キュラソー島'},
  {alpha: 'GR', name: 'ギリシャ'},
  {alpha: 'KI', name: 'キリバス'},
  {alpha: 'KG', name: 'キルギスタン'},
  {alpha: 'GT', name: 'グアテマラ'},
  {alpha: 'GP', name: 'グアドループ島'},
  {alpha: 'GU', name: 'グアム島'},
  {alpha: 'KW', name: 'クウェート'},
  {alpha: 'CK', name: 'クック諸島'},
  {alpha: 'GL', name: 'グリーンランド'},
  {alpha: 'CX', name: 'クリスマス島'},
  {alpha: 'GD', name: 'グレナダ'},
  {alpha: 'HR', name: 'クロアチア'},
  {alpha: 'KY', name: 'ケイマン諸島'},
  {alpha: 'KE', name: 'ケニア'},
  {alpha: 'CI', name: 'コートジボアール'},
  {alpha: 'CC', name: 'ココス諸島'},
  {alpha: 'CR', name: 'コスタリカ'},
  {alpha: 'KM', name: 'コモロ'},
  {alpha: 'CO', name: 'コロンビア'},
  {alpha: 'CD', name: 'コンゴ (キンシャサ)'},
  {alpha: 'CG', name: 'コンゴ (ブラザビル)'},
  {alpha: 'SA', name: 'サウジアラビア'},
  {alpha: 'GS', name: 'サウスジョージア島とサウスサンドウィッチ諸島'},
  {alpha: 'WS', name: 'サモア'},
  {alpha: 'ST', name: 'サントメ・プリンシペ'},
  {alpha: 'ZM', name: 'ザンビア'},
  {alpha: 'PM', name: 'サンピエール島およびミクロン島'},
  {alpha: 'SM', name: 'サンマリノ'},
  {alpha: 'MF', name: 'サンマルタン島 (フランス領)'},
  {alpha: 'SL', name: 'シエラレオネ'},
  {alpha: 'DJ', name: 'ジブチ'},
  {alpha: 'GI', name: 'ジブラルタル'},
  {alpha: 'JE', name: 'ジャージー島'},
  {alpha: 'JM', name: 'ジャマイカ'},
  {alpha: 'GE', name: 'ジョージア'},
  {alpha: 'SY', name: 'シリア'},
  {alpha: 'SG', name: 'シンガポール'},
  {alpha: 'SX', name: 'シント・マールテン (オランダ領)'},
  {alpha: 'ZW', name: 'ジンバブエ'},
  {alpha: 'SD', name: 'スーダン'},
  {alpha: 'CH', name: 'スイス'},
  {alpha: 'SJ', name: 'スヴァールバル諸島およびヤンマイエン島'},
  {alpha: 'SE', name: 'スウェーデン'},
  {alpha: 'ES', name: 'スペイン'},
  {alpha: 'SR', name: 'スリナム'},
  {alpha: 'LK', name: 'スリランカ'},
  {alpha: 'SK', name: 'スロバキア'},
  {alpha: 'SI', name: 'スロベニア'},
  {alpha: 'SZ', name: 'スワジランド'},
  {alpha: 'SC', name: 'セイシェル'},
  {alpha: 'SN', name: 'セネガル'},
  {alpha: 'RS', name: 'セルビア'},
  {alpha: 'SH', name: 'セント・ヘレナ島'},
  {alpha: 'KN', name: 'セントクリストファー・ネイビス'},
  {alpha: 'BL', name: 'セントバーツ島'},
  {alpha: 'VC', name: 'セントビンセントおよびグレナディーン諸島'},
  {alpha: 'LC', name: 'セントルシア'},
  {alpha: 'SO', name: 'ソマリア'},
  {alpha: 'SB', name: 'ソロモン諸島'},
  {alpha: 'TC', name: 'タークス・カイコス諸島'},
  {alpha: 'TH', name: 'タイ'},
  {alpha: 'TJ', name: 'タジキスタン'},
  {alpha: 'TZ', name: 'タンザニア'},
  {alpha: 'CZ', name: 'チェコ共和国'},
  {alpha: 'TD', name: 'チャド'},
  {alpha: 'TN', name: 'チュニジア'},
  {alpha: 'CL', name: 'チリ'},
  {alpha: 'TV', name: 'ツバル'},
  {alpha: 'DK', name: 'デンマーク'},
  {alpha: 'TG', name: 'トーゴ'},
  {alpha: 'DE', name: 'ドイツ'},
  {alpha: 'TK', name: 'トケラウ諸島'},
  {alpha: 'DM', name: 'ドミニカ'},
  {alpha: 'DO', name: 'ドミニカ共和国'},
  {alpha: 'TT', name: 'トリニダード・トバゴ'},
  {alpha: 'TM', name: 'トルクメニスタン'},
  {alpha: 'TR', name: 'トルコ'},
  {alpha: 'TO', name: 'トンガ'},
  {alpha: 'NG', name: 'ナイジェリア'},
  {alpha: 'NR', name: 'ナウル'},
  {alpha: 'NA', name: 'ナミビア'},
  {alpha: 'NU', name: 'ニウエ'},
  {alpha: 'NI', name: 'ニカラグア'},
  {alpha: 'NE', name: 'ニジェール'},
  {alpha: 'NZ', name: 'ニュージーランド'},
  {alpha: 'NP', name: 'ネパール'},
  {alpha: 'NF', name: 'ノーフォーク島'},
  {alpha: 'NO', name: 'ノルウェー'},
  {alpha: 'HM', name: 'ハード島とマクドナルド諸島'},
  {alpha: 'BH', name: 'バーレーン'},
  {alpha: 'HT', name: 'ハイチ'},
  {alpha: 'PK', name: 'パキスタン'},
  {alpha: 'VA', name: 'バチカン市国'},
  {alpha: 'PA', name: 'パナマ'},
  {alpha: 'VU', name: 'バヌアツ'},
  {alpha: 'BS', name: 'バハマ'},
  {alpha: 'PG', name: 'パプア・ニューギニア'},
  {alpha: 'BM', name: 'バミューダ諸島'},
  {alpha: 'PW', name: 'パラオ'},
  {alpha: 'PY', name: 'パラグアイ'},
  {alpha: 'BB', name: 'バルバドス'},
  {alpha: 'PS', name: 'パレスチナ'},
  {alpha: 'HU', name: 'ハンガリー'},
  {alpha: 'BD', name: 'バングラデシュ'},
  {alpha: 'PN', name: 'ピトケアン島'},
  {alpha: 'BV', name: 'ブーヴェ島'},
  {alpha: 'BT', name: 'ブータン'},
  {alpha: 'FJ', name: 'フィジー'},
  {alpha: 'PH', name: 'フィリピン'},
  {alpha: 'FI', name: 'フィンランド'},
  {alpha: 'PR', name: 'プエルトリコ'},
  {alpha: 'FO', name: 'フェロー諸島'},
  {alpha: 'FK', name: 'フォークランド諸島'},
  {alpha: 'BR', name: 'ブラジル'},
  {alpha: 'FR', name: 'フランス'},
  {alpha: 'GF', name: 'フランス領ギアナ'},
  {alpha: 'NC', name: 'フランス領ニューカレドニア'},
  {alpha: 'PF', name: 'フランス領ポリネシア'},
  {alpha: 'TF', name: 'フランス領南方・南極地域'},
  {alpha: 'BG', name: 'ブルガリア'},
  {alpha: 'BF', name: 'ブルキナファソ'},
  {alpha: 'BN', name: 'ブルネイ'},
  {alpha: 'BI', name: 'ブルンジ'},
  {alpha: 'VN', name: 'ベトナム'},
  {alpha: 'BJ', name: 'ベナン'},
  {alpha: 'VE', name: 'ベネズエラ'},
  {alpha: 'BY', name: 'ベラルーシ'},
  {alpha: 'BZ', name: 'ベリーズ'},
  {alpha: 'PE', name: 'ペルー'},
  {alpha: 'BE', name: 'ベルギー'},
  {alpha: 'PL', name: 'ポーランド'},
  {alpha: 'BA', name: 'ボスニア・ヘルツェゴビナ'},
  {alpha: 'BW', name: 'ボツワナ'},
  {alpha: 'BQ', name: 'ボネール、シント・ユースタティウスおよびサバ'},
  {alpha: 'BO', name: 'ボリビア'},
  {alpha: 'PT', name: 'ポルトガル'},
  {alpha: 'HN', name: 'ホンジュラス'},
  {alpha: 'MH', name: 'マーシャル諸島'},
  {alpha: 'MO', name: 'マカオ'},
  {alpha: 'MK', name: 'マケドニア'},
  {alpha: 'MG', name: 'マダガスカル'},
  {alpha: 'YT', name: 'マヨット島'},
  {alpha: 'MW', name: 'マラウィ'},
  {alpha: 'ML', name: 'マリ'},
  {alpha: 'MT', name: 'マルタ'},
  {alpha: 'MQ', name: 'マルティニーク島'},
  {alpha: 'MY', name: 'マレーシア'},
  {alpha: 'IM', name: 'マン島'},
  {alpha: 'FM', name: 'ミクロネシア連邦'},
  {alpha: 'MM', name: 'ミャンマー'},
  {alpha: 'MX', name: 'メキシコ'},
  {alpha: 'MU', name: 'モーリシャス'},
  {alpha: 'MR', name: 'モーリタニア'},
  {alpha: 'MZ', name: 'モザンビーク'},
  {alpha: 'MC', name: 'モナコ'},
  {alpha: 'MV', name: 'モルディブ'},
  {alpha: 'MD', name: 'モルドバ'},
  {alpha: 'MA', name: 'モロッコ'},
  {alpha: 'MN', name: 'モンゴル'},
  {alpha: 'ME', name: 'モンテネグロ'},
  {alpha: 'MS', name: 'モントセラト島'},
  {alpha: 'JO', name: 'ヨルダン'},
  {alpha: 'LA', name: 'ラオス'},
  {alpha: 'LV', name: 'ラトビア'},
  {alpha: 'LT', name: 'リトアニア'},
  {alpha: 'LY', name: 'リビア'},
  {alpha: 'LI', name: 'リヒテンシュタイン'},
  {alpha: 'LR', name: 'リベリア'},
  {alpha: 'RO', name: 'ルーマニア'},
  {alpha: 'LU', name: 'ルクセンブルク'},
  {alpha: 'RW', name: 'ルワンダ'},
  {alpha: 'LS', name: 'レソト'},
  {alpha: 'LB', name: 'レバノン'},
  {alpha: 'RE', name: 'レユニオン'},
  {alpha: 'WF', name: 'ワリー・エ・フトゥーナ諸島'},
  {alpha: 'CN', name: '中国'},
  {alpha: 'CF', name: '中央アフリカ共和国'},
  {alpha: 'MP', name: '北マリアナ諸島'},
  {alpha: 'ZA', name: '南アフリカ'},
  {alpha: 'SS', name: '南スーダン'},
  {alpha: 'AQ', name: '南極大陸'},
  {alpha: 'TW', name: '台湾'},
  {alpha: 'UM', name: '合衆国領有小離島'},
  {alpha: 'JP', name: '日本'},
  {alpha: 'TL', name: '東ティモール'},
  {alpha: 'AS', name: '米サモア'},
  {alpha: 'US', name: '米国'},
  {alpha: 'GB', name: '英国'},
  {alpha: 'GQ', name: '赤道ギニア'},
  {alpha: 'KR', name: '韓国'},
  {alpha: 'HK', name: '香港'},
]
